export const detailIdentifySupplierJobsStyle = (theme) => ({
  paperTitle: {
    margin: theme.spacing(0),
    padding: theme.spacing(1),
  },
  paperTable: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(0),
    padding: theme.spacing(0),
    background: "#FFFFFF",
    border: "1px solid #979797",
    borderRadius: "5px",
  },
  tableDetails: {
    "& th, td": {
      borderBottom: "0px solid rgba(224, 224, 224, 1) !important",
      color: "#404040 !important",
    },
  },
  tableCellLabelHeaderTitle: {
    fontSize: "16px",
    color: "#2B2B2B",
    letterSpacing: "0.13px",
  },

  tableCellLabelBodyDetails: {
    fontWeight: "bold",
    padding: "1px 4px 1px 16px",
  },

  tableCellLabelHeaderSubtitleDetails: {
    fontSize: "12px",
    color: "#585858",
    letterSpacing: "0.1px",
    padding: "1px 4px 1px 16px",
  },

  tableCellLabelHeaderAndBodyDetails108: {
    width: "108px",
    display: "inline-block",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },

  tableCellLabelHeaderAndBodyDetails270: {
    width: "270px",
    display: "inline-block",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },

  tableCellLabelHeaderAndBodyDetails100: {
    width: "100px",
    display: "inline-block",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },

  tableCellLabelHeaderAndBodyDetails114: {
    width: "114px",
    display: "inline-block",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },

  tableCellLabelListItem: {
    fontSize: "14px",
    color: "#2B2B2B",
    letterSpacing: "0.11px",
  },

  tableCellLabelHeaderTitleLog: {
    fontWeight: "800",
    fontSize: "14px",
    color: "#2B2B2B",
    letterSpacing: "0.11px",
  },

  tableContainer: {
    paddingBottom: theme.spacing(0),
  },
});
